import { DynamicAccountingKey, MeetingServiceTabValues } from "../../form/formTypes"
import { isAccountingDimensionKey } from "../../form/helpers"
import { FieldEntry } from "./DimensionsGuardManager"

const hasKey = <K extends string>(obj: unknown, key: K): obj is Record<K, unknown> =>
    typeof obj === "object" && obj !== null && key in obj

function isNonEmptyString(x: unknown): x is string {
    return typeof x === "string" && x.trim().length > 0
}

export function hasDimAndValue(v: unknown): v is { dimensionId: number; value: string } {
    if (!hasKey(v, "dimensionId") || typeof v.dimensionId !== "number") return false
    if (!hasKey(v, "value") || !isNonEmptyString(v.value)) return false
    return true
}
export function collectValidEntries(values: MeetingServiceTabValues): FieldEntry[] {
    return Object.entries(values)
        .filter((entry): entry is [DynamicAccountingKey, unknown] => isAccountingDimensionKey(entry[0]))
        .reduce<FieldEntry[]>((acc, [k, v]) => {
            if (hasDimAndValue(v)) {
                acc.push({
                    key: k,
                    value: v,
                    dimensionIdFromConfig: v.dimensionId,
                })
            }
            return acc
        }, [])
        .sort((a, b) => {
            const da = a.dimensionIdFromConfig
            const db = b.dimensionIdFromConfig
            if (da !== db) return da - db
            const na = Number(a.key.split("_")[2])
            const nb = Number(b.key.split("_")[2])
            return na - nb
        })
}

const isScalar = (x: unknown): x is string | number => typeof x === "string" || typeof x === "number"

export const extractValue = (v: unknown): string | null => {
    if (v == null) return null
    if (isScalar(v)) return String(v)
    if (hasKey(v, "value") && isScalar(v.value)) return String(v.value)
    if (hasKey(v, "id") && isScalar(v.id)) return String(v.id)
    return null
}
